/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Deals_Actual_CloseInputs */

const cs_deals_actual_close = /** @type {(inputs: Deals_Actual_CloseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Skutečné uzavření`)
};

const en_deals_actual_close = /** @type {(inputs: Deals_Actual_CloseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Actual close`)
};

/**
* | output |
* | --- |
* | "Actual close" |
*
* @param {Deals_Actual_CloseInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const deals_actual_close = /** @type {((inputs?: Deals_Actual_CloseInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Deals_Actual_CloseInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_deals_actual_close(inputs)
	return cs_deals_actual_close(inputs)
});